import React, { useState } from "react";
import { auth, db } from "./firebase";
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";

export default function AuthForm({ onAuth }) {
  const [isRegister, setIsRegister] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      let userCred;
      if (isRegister) {
        userCred = await createUserWithEmailAndPassword(auth, email, password);
        // Create user profile doc in Firestore
        console.log("WRITING TO FIRESTORE from <filename> Authform 2")

        await setDoc(doc(db, "users", userCred.user.uid), {
          email,
          skillsOffered: [],
          skillsWanted: [],
          availability: {},
        });
      } else {
        userCred = await signInWithEmailAndPassword(auth, email, password);
      }
      onAuth && onAuth(userCred.user);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 350, margin: "40px auto", padding: 24, border: "1px solid #ddd", borderRadius: 8 }}>
      <h2>{isRegister ? "Register" : "Login"}</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          style={{ width: "100%", marginBottom: 10, padding: 8 }}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
          style={{ width: "100%", marginBottom: 10, padding: 8 }}
        />
        {error && <div style={{ color: "red", marginBottom: 10 }}>{error}</div>}
        <button type="submit" disabled={loading} style={{ width: "100%", padding: 8 }}>
          {loading ? "Please wait..." : isRegister ? "Register" : "Login"}
        </button>
      </form>
      <div style={{ margin: "16px 0", textAlign: "center" }}>
        <button
          type="button"
          style={{ background: "#fff", border: "1px solid #ddd", borderRadius: 4, padding: 8, width: "100%", display: "flex", alignItems: "center", justifyContent: "center", gap: 8, cursor: "pointer" }}
          onClick={async () => {
            setError("");
            setLoading(true);

            try {
              const provider = new GoogleAuthProvider();
              const result = await signInWithPopup(auth, provider);
              const userDoc = doc(db, "users", result.user.uid);
            
              // Check if the user profile doc already exists
              const docSnap = await getDoc(userDoc);
              if (!docSnap.exists()) {
                console.log("WRITING TO FIRESTORE from <filename> Authform 1 - Creating new profile");
                await setDoc(userDoc, {
                  email: result.user.email,
                  skillsOffered: [],
                  skillsWanted: [],
                  availability: {},
                });
              } else {
                console.log("User profile already exists, not overwriting.");
              }
            
              onAuth && onAuth(result.user);
            } catch (err) {
              setError(err.message);
            } finally {
              setLoading(false);
            }
            
          }}
        >
          <span style={{ fontWeight: 600 }}>&#x1F5D3;</span> Sign in with Google
        </button>
      </div>
      <div style={{ marginTop: 10 }}>
        {isRegister ? "Already have an account?" : "Don't have an account?"}
        <button
          style={{ marginLeft: 8, background: "none", border: "none", color: "#1976d2", cursor: "pointer", textDecoration: "underline" }}
          onClick={() => setIsRegister(r => !r)}
        >
          {isRegister ? "Login" : "Register"}
        </button>
      </div>
    </div>
  );
}
